






























































import {Component, Vue, Prop, Watch} from 'vue-property-decorator';

@Component({})
export default class FindPeaksMenuButton extends Vue {
  @Prop({required: true, type: String, default: ''})
  tooltip!: string;

  @Prop({required: true, type: String, default: ''})
  alterTooltip!: string;

  @Prop({required: true, type: String})
  icon!: string;

  //null для исправления бага
  activeState: number | undefined | null = null;

  @Prop({required: true})
  applyStatus!: boolean;

  menu = false;

  value = 3;

  //TODO:
  key = 0;

  @Watch('menu')
  bugFix(value: boolean) {
    if (!value) {
      this.activeState = null;
      this.key++;
    }
  }

  @Prop({type: Boolean, default: false})
  disabled!: string;

  @Prop({default: () => ({})})
  activators!: {};

  click(e: any) {
    this.menu = false;
    this.$emit('click', e);
  }

  change() {
    this.$emit('change', this.activeState);
  }
}
